import moment from "moment";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import PendenciasFinanceiras from "../../common/query/PendenciasFinanceiras";
import Protestos from "../../common/query/Protestos";
import ChequesSemFundos from "../../common/query/ChequesSemFundos";
import ParticipacaoEmEmpresas from "../../common/query/ParticipacaoEmEmpresas";
import {
  buildDurationLabel,
  formatDocument,
  formatToReal,
  getColorScore,
  getImageURLScoreSerasa,
  maskCEP,
} from "../../../utils/utils";
import { useState } from "react";
import { Modal } from "flowbite-react";
import StreetView from "../../common/query/StreetView";
import ModalReceitaFederal from "../../modals/ModalReceitaFederal";
import ScoreRating from "./ScoreRating";
import { FaRegChartBar, FaUserCheck } from "react-icons/fa";
import { IoReceiptOutline } from "react-icons/io5";
import { TfiBarChart } from "react-icons/tfi";
import { LuBuilding2 } from "react-icons/lu";
import { BsBank } from "react-icons/bs";
import {
  GrDocumentExcel,
  GrDocumentText,
  GrDocumentTime,
  GrMoney,
} from "react-icons/gr";
import { CiMoneyCheck1 } from "react-icons/ci";
import { MdOutlineBalance } from "react-icons/md";
import { HiOutlineCurrencyDollar, HiOutlineEye } from "react-icons/hi";
import { FiUserCheck, FiUsers } from "react-icons/fi";
import { BiLineChartDown } from "react-icons/bi";

const SpcTerceirosQuery = ({ data, dataFull }) => {
  const [openMap, setOpenMap] = useState(false);

  const cadastro = data?.dadosCadastrais || {};
  const fullAddress = [
    cadastro.endereco,
    cadastro.numero,
    cadastro.bairro,
    cadastro.cidade,
    cadastro.cep,
  ]
    .filter(Boolean)
    .join(", ");
  const isPJ = Boolean(cadastro.cnpj);
  const foundationMoment =
    isPJ && cadastro.dataFundacao
      ? moment(
          cadastro.dataFundacao,
          ["DD/MM/YYYY", "YYYY-MM-DD", "YYYYMMDD"],
          true
        )
      : null;
  const foundationLabel =
    foundationMoment && foundationMoment.isValid()
      ? foundationMoment.format("DD/MM/YYYY")
      : null;
  const foundationAgeLabel = buildDurationLabel(
    foundationMoment,
    "de atividade"
  );

  const birthMoment =
    !isPJ && cadastro.dataNascimento
      ? moment(cadastro.dataNascimento, ["DD/MM/YYYY", "YYYY-MM-DD"], true)
      : null;
  const birthLabel =
    birthMoment && birthMoment.isValid()
      ? birthMoment.format("DD/MM/YYYY")
      : null;
  const birthYears =
    birthMoment && birthMoment.isValid()
      ? moment().diff(birthMoment, "years")
      : null;
  const birthAgeLabel =
    birthYears != null
      ? `${birthYears} ano${birthYears === 1 ? "" : "s"}`
      : null;

  return (
    <>
      <div>
        <TitleStripe>
          <div className="flex items-center gap-2">
            {data?.dadosCadastrais?.cpf ? (
              <FiUserCheck className="text-blue-700" />
            ) : (
              <LuBuilding2 className="text-blue-700" />
            )}

            <span>Dados Cadastrais / Base III</span>
          </div>
        </TitleStripe>

        <div className="mt-4 text-xs">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
                {data?.dadosCadastrais?.cnpj ? "Razão Social" : "Nome"}
              </p>
              <p className="text-lg font-semibold text-gray-900">
                {data?.dadosCadastrais?.cnpj
                  ? data?.dadosCadastrais?.razaoSocial || "Indisponível"
                  : data?.dadosCadastrais?.nome || "Indisponível"}
              </p>
              <p className="text-[11px] text-gray-500">
                {data?.dadosCadastrais?.cnpj
                  ? data?.dadosCadastrais?.nomeFantasia || "Sem nome fantasia"
                  : data?.dadosCadastrais?.cpf || "CPF não informado"}
              </p>
            </div>
            {data?.dadosCadastrais?.cnpj && (
              <ModalReceitaFederal cnpj={data?.dadosCadastrais?.cnpj} />
            )}
          </div>

          <div className="mt-2 flex flex-wrap gap-2 text-[10px] text-gray-500">
            {data?.dadosCadastrais?.cpf && (
              <span className="inline-flex items-center rounded-full border border-gray-200 bg-slate-50 px-2 py-0.5">
                {data?.dadosCadastrais?.cpf
                  ? `Nascimento: ${birthLabel || "—"}`
                  : null}
              </span>
            )}

            {data?.dadosCadastrais?.cnpj && foundationAgeLabel && (
              <span className="inline-flex items-center rounded-full border border-gray-200 bg-slate-50 px-2 py-0.5">
                {foundationAgeLabel}
              </span>
            )}
            {!data?.dadosCadastrais?.cnpj && birthAgeLabel && (
              <span className="inline-flex items-center rounded-full border border-gray-200 bg-slate-50 px-2 py-0.5">
                {birthAgeLabel}
              </span>
            )}
          </div>

          <div className="mt-3 grid gap-2 grid-cols-2">
            {(isPJ
              ? [
                  {
                    label: "CNPJ / MF",
                    value: data?.dadosCadastrais?.cnpj
                      ? formatDocument(data?.dadosCadastrais?.cnpj)
                      : "Não disponível",
                    hint: "Documento",
                  },
                  {
                    label: "CNAE",
                    value: data?.dadosCadastrais?.ramoAtividade || "—",
                    hint: "Atividade",
                  },
                ]
              : [
                  {
                    label: "CPF",
                    value: formatDocument(data?.dadosCadastrais?.cpf),
                    hint: "Documento",
                  },
                  {
                    label: "Origem CPF",
                    value: data?.dadosCadastrais?.regiaoCPF || "—",
                    hint: "Região",
                  },
                ]
            ).map((item) => (
              <div
                key={item.label}
                className="rounded-xl border border-gray-100 bg-slate-50 px-3 py-2"
              >
                <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
                  {item.label}
                </p>
                <p className="text-base font-semibold text-gray-900">
                  {item.value}
                </p>
                <p className="text-[10px] text-gray-500">{item.hint}</p>
              </div>
            ))}
          </div>

          {data?.dadosCadastrais?.endereco && (
            <>
              <TitleStripe className="mt-4 mb-3">
                <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-gray-500">
                  <LuBuilding2 className="text-blue-700" />{" "}
                  <span>Localização</span>
                </div>
              </TitleStripe>
              <div className="grid gap-2 sm:grid-cols-2">
                <div className="rounded-xl border border-gray-100 bg-white px-3 py-2">
                  <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
                    Endereço
                  </p>
                  <p className="text-[12px] font-semibold text-gray-900">
                    {data?.dadosCadastrais?.endereco || "—"}
                  </p>
                </div>
                <div className="rounded-xl border border-gray-100 bg-white px-3 py-2">
                  <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
                    Bairro · CEP
                  </p>
                  <p className="text-[12px] font-semibold text-gray-900 flex flex-wrap gap-1">
                    <span>{data?.dadosCadastrais?.bairro || "—"}</span>
                    <span>·</span>
                    <span>{maskCEP(data?.dadosCadastrais?.cep) || "--"}</span>
                  </p>
                </div>
              </div>
              <div className="mt-2 grid gap-2 sm:grid-cols-2">
                <div className="rounded-xl border border-gray-100 bg-white px-3 py-2">
                  <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
                    Cidade
                  </p>
                  <p className="text-[12px] font-semibold text-gray-900">
                    {data?.dadosCadastrais?.cidade || "—"}
                  </p>
                </div>
                <div className="rounded-xl border border-gray-100 bg-white px-3 py-2">
                  <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
                    UF
                  </p>
                  <p className="text-[12px] font-semibold text-gray-900">
                    {data?.dadosCadastrais?.uf || "--"}
                  </p>
                </div>
              </div>
              {fullAddress && (
                <div className="mt-2 flex items-center gap-1 text-[11px] text-blue-600 cursor-pointer">
                  <span>- Ver fotos do local</span>
                  <HiOutlineEye className="text-base" />
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {dataFull?.scoreRating?.statusRetorno == 1 && (
        <ScoreRating score={dataFull?.scoreRating} block={false} />
      )}
      <div>
        <TitleStripe className="mb-4">
          <div className="flex items-center gap-2">
            <HiOutlineCurrencyDollar className="text-blue-700" />
            <span>Pendências Financeiras / Base II</span>
          </div>
        </TitleStripe>

        {data?.pendenciasFinanceiras?.length > 0 ? (
          <div className="flex gap-2 items-start">
            <div className="flex-1">
              <PendenciasFinanceiras
                quantidadeTotal={data?.resumoConsulta?.serasa?.quantidadeTotal}
                valorTotal={data?.resumoConsulta?.serasa?.valorTotal}
                pendenciasFinanceiras={data?.pendenciasFinanceiras}
              />
            </div>
          </div>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div>
        <TitleStripe className="mb-4">
          <div className="flex items-center gap-2">
            <HiOutlineCurrencyDollar className="text-blue-700" />
            <span>Restrições Financeiras / Base III</span>
          </div>
        </TitleStripe>

        {data?.spc?.length > 0 ? (
          <div className="flex gap-2 items-start">
            <div className="flex-1">
              <PendenciasFinanceiras
                quantidadeTotal={data?.resumoConsulta?.spc?.quantidadeTotal}
                valorTotal={data?.resumoConsulta?.spc?.valorTotal}
                pendenciasFinanceiras={data?.spc}
              />
            </div>
          </div>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div>
        <TitleStripe className="mb-4">
          <div className="flex items-center gap-2">
            <GrDocumentExcel className="text-blue-700" />
            <span>Títulos protestados / Base III</span>
          </div>
        </TitleStripe>

        {data?.protestos?.length > 0 ? (
          <div className="flex gap-2 items-start">
            <div className="flex-1">
              <Protestos
                quantidadeTotal={
                  data?.resumoConsulta?.protestos?.quantidadeTotal
                }
                valorTotal={data?.resumoConsulta?.protestos?.valorTotal}
                protestos={data?.protestos}
              />
            </div>
          </div>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <Modal show={openMap} onClose={() => setOpenMap(false)} size="5xl">
        <Modal.Header>Localização</Modal.Header>
        <Modal.Body>
          <div className="space-y-2">
            <div className="text-sm text-gray-600">
              <strong>Endereço:</strong> {fullAddress || "—"}
            </div>
            {fullAddress ? (
              <StreetView address={fullAddress} height={460} />
            ) : (
              <div className="p-3 text-sm text-gray-500">
                Endereço indisponível.
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SpcTerceirosQuery;
